import * as React from 'react';
import dayjs from "dayjs";
import {Icon, t, Table, Text} from "owc-react-lib-common";
import {View} from "src/components/View";
import {REGISTER_STATUS_COMPLETED} from 'src/pages/public/actor/IRegistrationProcess';
import * as CompetitionService from 'src/services/CompetitionService';
import {useAlerts} from 'src/hooks/useAlerts';
import { ITeamDTO } from 'src/services/TeamService';

interface IRegisterTeam3x3Team {
  disabled?: boolean;
  teams: ITeamDTO[];
  eventCategory: any;
  onSelectTeam: (team: any) => void;
}

export const RegisterTeam3x3Team = ({disabled = false, teams, eventCategory, onSelectTeam}: IRegisterTeam3x3Team) => {
  const [duplicateNameTeamIds, setDuplicateNameTeamIds] = React.useState<number[]>([]);
  const {createDSMError} = useAlerts();

  React.useEffect(() => {
    const validateTeamNames = async () => {
      try {
        if (teams.length > 0 && eventCategory) {
          const response = await CompetitionService.checkTeamNamesInCompetition(eventCategory.competitionId, teams.map(t => t.id));
          setDuplicateNameTeamIds(response.data.map((t: ITeamDTO) => t.id));
        }
      } catch (error) {
        createDSMError(error);
      }
    };

    validateTeamNames();
  }, [teams, eventCategory]);

  const data = React.useMemo(() => {
    return teams.map((team: ITeamDTO) => {
      const errors: string[] = [];

      // team already registered
      if (team?.teamEventCategories?.some((teamEventCategory: any) => teamEventCategory.eventCategory.id === eventCategory?.id)) {
        errors.push(t('3x3.register.errors.alreadyRegistered'));
      }

      // team with the same name already exists in competition
      if (duplicateNameTeamIds.includes(team.id)) {
        errors.push(t('3x3.register.errors.alreadyRegisteredWithSameName'));
      }

      // equip registrat a una altra categoria si la competicio no ho permet
      if (!eventCategory?.competitionAllowTeamDiferentCategory && (team?.teamEventCategories?.some((teamEventCategory: any) => teamEventCategory.eventCategory.categoryId !== eventCategory?.categoryId))) {
        errors.push(t('3x3.register.errors.alreadyRegisteredInOtherCategory'));
      }

      // gender requirements
      if (eventCategory?.gender === 'F' && team?.actors?.some((actor: any) => actor.gender === 'M')) {
        errors.push(t('3x3.register.errors.wrongGender'));
      }

      // age requirements
      if (team.actors.some((actor: any) => dayjs(actor.formattedPeopleBirthdate, "DD/MM/YYYY").isBefore(dayjs(eventCategory?.earliestBirthdate))
          || dayjs(actor.formattedPeopleBirthdate, "DD/MM/YYYY").isAfter(dayjs(eventCategory?.latestBirthdate)))) {
        errors.push(t('3x3.register.errors.wrongAge'));
      }

      // actor amount requirement
      const actorAmount = team.actors.filter((actor: any) => actor.registrationStatus >= REGISTER_STATUS_COMPLETED).length;

      if (actorAmount < (eventCategory?.minPlayers || 0) /*|| actorAmount > (eventCategory?.maxPlayers || 99)*/) {
        errors.push(t('3x3.register.errors.wongActorNumber', {actorAmount: actorAmount}));
      }

      // data
      return [
        team.name,
        <View key={team.uuid}>
          {errors.length ? errors.map((error: string) => <Text color='crimson' key={error}>{error}</Text>) :
              <Text color='teal'>{t('3x3.register.errors.validTeam')}</Text>}
        </View>,
        <View key={team.uuid + errors.length}>
          {!!errors.length && <Icon type='exclamation-circle' color='crimson'/>}
          {!errors.length && !disabled && <Icon type='arrowright' onPress={() => onSelectTeam(team)}/>}
        </View>
      ];
    });
  }, [duplicateNameTeamIds, disabled, teams, eventCategory, onSelectTeam]);

  return (
      <Table pagination={false} headers={[{label: t('3x3.register.name'), width: 400}, {key: 'errors'}, {key: 'actions', width: 120, justifyContent: 'flex-end'}]} data={data}/>
  );
};